import type { State } from '../../types';

export const getHubLinkedState = (state: State) => state.entities.hub.linkedState;

export const getLinkedConfluenceUrl = (state: State) =>
	state.entities.hub.linkedState === 'linked' ? state.entities.hub.confluenceUrl : undefined;

export const getLinkedConfluenceSpace = (state: State) =>
	state.entities.hub.linkedState === 'linked' ? state.entities.hub.spaceKey : undefined;
